import { ColumnDirective, ColumnsDirective, GridComponent, Inject, Page, Sort } from "@syncfusion/ej2-react-grids";

const StoresList = ({ stores, setEdit, setEditableStore }) => {

    const handleEdit = (store) => {
        setEdit(true);
        setEditableStore(store);
    }

    const handleQueryCellInfo = (args) => {
        if (args.column.field === "active" || args.column.field === "headquarter") {
            args.cell.style.color = "green";
        }
    };

    return (
        <GridComponent dataSource={stores} allowSorting allowPaging queryCellInfo={handleQueryCellInfo} pageSettings={{ pageSize: 30 }}>
            <ColumnsDirective>
                <ColumnDirective field='_id' headerText="ID" width='200' textAlign="Center" />
                <ColumnDirective field='name' width='150' headerText="Nome" textAlign="Center" />
                <ColumnDirective field='city' width='100' headerText="Cidade" textAlign="Center" />
                <ColumnDirective field='state' width='100' headerText="Estado" textAlign="Center" />
                <ColumnDirective field='active' width='100' headerText="Ativa" textAlign="Center" valueAccessor={(f, d) => { return d?.active ? "✔" : null }} />
                <ColumnDirective field='headquarter' width='100' headerText="Headquarter" textAlign="Center" valueAccessor={(f, d) => { return d?.headquarter ? "✔" : null }} />
                <ColumnDirective width='100' textAlign="Center" template={(d, f) => { return <button onClick={() => handleEdit(d)} className="bg-blue-500 hover:bg-blue-800 px-2 text-black">Ver</button> }} />
            </ColumnsDirective>
            <Inject services={[Sort, Page]} />
        </GridComponent>
    )
}

export default StoresList;
